<template>
  <div>
    <h3>{{department.title}}</h3>
    <div v-html="department.content"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      department: ""
    };
  },
  created: function() {
    this.get_department();
  },
  methods: {
    get_department() {
      let url = "departments/?ordering=index";
      this.$http.get(url).then(response => {
        this.department = response.data[0];
      });
    }
  },
};
</script>
<style lang="scss" scoped>
</style>
